// src/config.js

// 开发环境后端地址
const devApiUrl = 'http://127.0.0.1:8087/dataServiceBg/smallApi/';
const devBaseUrl = 'http://127.0.0.1:8087/dataServiceBg';
const devConsoleUrl = 'http://localhost:80/consoleIndex';

// 正式环境后端地址
const prodApiUrl = 'https://open.zptdata.com/dataServiceBg/smallApi/';
const prodBaseUrl = 'https://open.zptdata.com/dataServiceBg';
const prodConsoleUrl = 'https://open.zptdata.com/consoleIndex/consoleIndex';

module.exports = {
    devApiUrl,
    devBaseUrl,
    devConsoleUrl,
    prodApiUrl,
    prodBaseUrl,
    prodConsoleUrl
};